<template>
  <div class="search">
    <community-header :headerIndex="headerindex" @headerClick="indexFn"></community-header>
    <div class="h" v-if="headerindex != 0 && headerindex != 3"></div>
    <community-center
      ref="communityCenter"
      v-if="headerindex == 0"
      :newperson="newperson"
      :type="'comp'"
    ></community-center>
    <community-hot
      v-else-if="headerindex == 1"
      :newperson="newperson"
      :type="'comp'"
    ></community-hot>
    <community-follow
      v-else-if="headerindex == 2"
      :newperson="newperson"
      :type="'comp'"
      :markPointData="{ scenepoint: 'COMMUNITYSUBPOST' }"
    ></community-follow>
    <beautity-said v-else-if="headerindex == 3"></beautity-said>
    <van-overlay :show="popup.ispopu" v-if="popup.ispopu" z-index="99999">
      <div class="wrapper">
        <div class="block">
          <img :src="popup.img" @click="popup.ispopu = 0" />
          <div class="popup-p" v-if="popup.content">
            <p>恭喜您!</p>
            <span class="f16">{{ popup.content }}</span>
            <button @click="popup.ispopu = 0" class="bluebtn">我知道了</button>
          </div>
          <van-icon v-if="!popup.content" @click="popup.ispopu = 0" name="close" size="0.3rem" />
        </div>
      </div>
    </van-overlay>
    <van-overlay :show="is_pop" v-if="is_pop && popup_ads && popup_ads.img_path" z-index="99999">
      <div class="wrapper">
        <div class="block" @click.stop>
          <div style="position: relative">
            <img :src="popup_ads.img_path" @click="goAct('')" />
            <div
              :path="
                popup_ads.ad_target +
                (popup_ads.ad_target.indexOf('?') >= 0 ? '&' : '?') +
                'sorce=9'
              "
              :username="'gh_5d4bb8e18b8b'"
              class="slide_cl_xcx"
              v-if="isWx && (popup_ads.ad_type == 7 || popup_ads.ad_type == 8)"
            ></div>
          </div>
          <van-icon name="close" @click="is_pop = false" />
        </div>
      </div>
    </van-overlay>
    <footer-comp :footer-index="index" :cartnum="cartnum"></footer-comp>
  </div>
</template>

<script>
import communityHeader from '../common/communityHeader'
import communityCenter from '../community/communityCenter'
import communityHot from '../community/communityHot'
import communityFollow from '../community/communityFollow'
import beautitySaid from '../community-beautitysaid/index.vue'
import footerComp from '../common/footerComp'
// import follow from '../common/follow'
import Scroller from '../common/Scroller'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
import communityItem from '../common/communityItem'
import {
  isWeixin,
  fenxiang,
  cartNum,
  popType,
  bannerClick,
  goXcxCreateBtnFn
} from '../../assets/common/js/config'
import Vue from 'vue'

Vue.use(VueAwesomeSwiper /* { default global options } */)

export default {
  name: 'communityIndex',
  components: {
    communityHeader,
    communityCenter,
    communityHot,
    communityFollow,
    beautitySaid,
    footerComp,
    // follow,
    Scroller,
    communityItem
  },
  data: function () {
    return {
      index: 2,
      headerindex:
        this.$store.state.communityTab == 0 || 1 || 2 ? this.$store.state.communityTab : 1,
      popup: {
        ispopu: 0,
        img: '',
        content: ''
      },
      cartnum: 0,
      community_popup_ads: {},
      is_pop: false,
      popup_ads: {},
      isWx: isWeixin() ? 1 : 0,
      newperson: {}
    }
  },
  mounted: function () {
    // this.getOrdPop()
  },
  beforeRouteEnter(to, from, next) {
    if (!sessionStorage.askPositon || (from.path == '/' && from.name != 'homePage')) {
      // 当前页面刷新不需要切换位置
      sessionStorage.askPositon = ''
      next((vm) => {
        if (isWeixin()) fenxiang({ path: 'communityindex' })
        if (vm.headerindex == 0) {
          vm.$nextTick(function () {
            vm.$refs.communityCenter.getMain()
          })
        }
        vm.getPopup()
        vm.$clickburiedPoint({
          url: 'community/userbehavior/save'
        })
      })
    } else {
      next((vm) => {
        if (isWeixin()) fenxiang({ path: 'communityindex' })
        if (vm.headerindex == 0) {
          vm.$nextTick(function () {
            vm.$refs.communityCenter.getMain()
          })
        }
        cartNum((num) => (vm.cartnum = num))
        vm.getPopup()
        vm.$clickburiedPoint({
          url: 'community/userbehavior/save'
        })
        if (vm && vm.$refs.my_scroller) {
          // 通过vm实例访问this
          setTimeout(function () {
            window.scrollTo(0, sessionStorage.askPositon, false)
          }, 0) // 同步转异步操作
        }
      })
    }
  },
  beforeRouteLeave(to, from, next) {
    // 记录离开时的位置
    sessionStorage.askPositon = this.$refs.my_scroller && this.$refs.my_scroller.clickItem()
    next()
  },
  watch: {
    headerindex(id) {
      if (id == 0) {
        this.$nextTick(function () {
          this.$refs.communityCenter.getMain()
        })
      } else if (id == 1 && this.popup.ispopu != 1) {
        this.getOrdPop()
      }
    }
  },
  methods: {
    // 社区弹窗
    getOrdPop: function () {
      this.$customRequestAjax(this.$ajax.getMallCommunityIndexPop_URL).then((res) => {
        if (res.data.code == 200) {
          this.community_popup_ads = res.data.popup_ads
          this.ordPopFn()
        }
      })
      this.$newuserFn((data) => {
        if (data.code == 200) {
          this.newperson = {
            isnewpersontask: data.isnewpersontask,
            newpersonjump: data.newpersonjump ? data.newpersonjump : ''
          }
        }
      })
    },

    // 社区弹窗
    ordPopFn: function () {
      let type = 'communityPop',
        that = this
      popType(3, this.community_popup_ads, type, function () {
        that.is_pop = true
        that.popup_ads = that.community_popup_ads
      }) // 设为100 意为 需求：不限制次数
      setTimeout(() => {
        goXcxCreateBtnFn(this)
      }, 500)
    },
    goAct: function (flowArea) {
      this.is_pop = false
      bannerClick(this.popup_ads, 0, flowArea, this, () => {
        this.dataCollection(this.popup_ads, 0, flowArea)
      })
    },
    dataCollection(items, index, flowArea) {
      let params = {
        flowArea_var: flowArea, // 区域
        position_var: index, // 坑位
        flowName_var: flowArea == '热门直播' ? items.name : items.ad_title || '', // 流量位名称
        productName_var: flowArea == '热门直播' ? '' : items.name || '' // 商品名称
      }

      // 首页-流量位-埋点事件
      gio('track', 'flowLocationClick', params)
      // 首页-流量位-区域-转化变量
      gio('evar.set', 'flowArea_evar', flowArea)
      // 首页-流量位-区域-坑位-转化变量
      let value = flowArea == '热门直播' ? items.name : items.ad_title || ''
      gio('evar.set', 'flowName_evar', value)
    },

    indexFn(id) {
      let buttonCode = ''
      if (id == 0) {
        buttonCode = 'communityindex'
      } else if (id == 1) {
        buttonCode = 'hottopic'
      } else if (id == 2) {
        buttonCode = 'follow'
      } else {
        buttonCode = 'beautytalk'
      }
      this.$clickburiedPoint({
        data: {
          buttonCode: buttonCode
        },
        url: 'community/userbehavior/save'
      })
      this.headerindex = id
    },
    // followFn: function (data) {
    //   this.follow = data
    // },
    async getPopup() {
      var url = this.$ajax.getIndexPopu_community_URL
      let { data } = await this.$customRequestAjax(url)
      if (sessionStorage.getItem('communityevaluation_pop_img') && data.popu.ispopu == 0) {
        this.popup = {
          ispopu: 1,
          img: sessionStorage.getItem('communityevaluation_pop_img'),
          content: ''
        }
        sessionStorage.removeItem('communityevaluation_pop_img')
      } else {
        this.popup = Object.assign({}, this.popup, data.popu)
      }
      if (this.popup.ispopu != 1 && this.headerindex == 1) {
        this.getOrdPop()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.h {
  height: 0.46rem;
}
.f {
  height: 0.57rem;
}
.block {
  width: 80%;
  position: relative;
}
.popup-p {
  position: absolute;
  left: 0;
  right: 0;
  top: 1.2rem;
  padding: 0.1rem 0.27rem !important;
  p {
    font-size: 0.27rem;
    text-align: center;
    color: #333333;
    font-weight: bold;
  }
  span {
    display: block;
    text-align: left;
    color: #333333;
  }
  .bluebtn {
    background: #ff5900;
    border-width: 0;
    font-size: 0.2rem;
    color: #ffffff;
    border-radius: 0.18rem;
    width: 1.47rem;
    height: 0.36rem;
    line-height: 0.36rem;
    margin-top: 0.4rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/community/communityIndex.vue